import React, { Component, Fragment, lazy, Suspense } from 'react';
import { snowmindsConfig } from '../../configuration';
import axios from 'axios';
import { getComponent } from '../../routes/component';
import { routes } from '../home/dummyData';
//import { routes } from '../home/dummyData';
//import '../../assets/plugins.css';

let routeArrayCollection = [];
class MasterLayout extends Component {
    constructor(props) {
        super(props)

        this.state = {
            routecollection: null
        }
    }
    componentDidMount() {
        let snowminds = snowmindsConfig.getSnowMindsConfiguration();
        const url = `${snowminds.getallroutesApi}`;
        let param = {
            currentcontentid: document.getElementById("hdPageId") !== null ? document.getElementById("hdPageId").value : 0,
            language: document.getElementById("hdLanguage") !== null ? document.getElementById("hdLanguage").value : "en-US",
        };
        return new Promise((resolve, reject) => {

            axios.get(url, { params: param }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            })
                .then(res => {
                    if (res.data && res.data.routes) {
                        const {navigation={},homeRoute}=res.data;
                        const { nav} =navigation;
                        res.data.routes.map((response, index) => {
                            let reactComponent = getComponent(response.component);
                            routeArrayCollection.push({ component: reactComponent, jsonresponse: response });
                        })
                        this.setState({
                            isLoaded: true,
                            routecollection: routeArrayCollection,
                            logo: res.data.logo,
                            navigation: nav,
                            homeRoute:homeRoute
                        });
                    }

                })
        });

        // let response =  routes();

        // response.routes.map((response, index) => {
        //     let reactComponent = getComponent(response.component);
        //     routeArrayCollection.push({ component: reactComponent, jsonresponse: response });
        // })
        // const {navigation={},homeRoute}=response;
        // const { nav} =navigation;
        // this.setState({
        //     isLoaded: true,
        //     routecollection: routeArrayCollection,
        //     navigation: nav,
        //     logo: response.logo,
        //     homeRoute:homeRoute
        // });
    }
    HeaderComponent = lazy(() => import('../common/Header'));
    // FooterComponent=lazy(()=>import('../common/Footer'));
    BodyComponent = lazy(() => import('../body/Body'));
    render() {
        return (
            <Fragment>

                {(() => {
                    if (this.state.routecollection !== null) {
                        return <Fragment>
                            <Suspense fallback={<div></div>}>
                                {/* <this.HeaderComponent navigation={this.state.navigation} routes={this.state.routecollection}
                                 logo={this.state.logo} homePageUrl={this.state.homeRoute}  /> */}
                                <this.BodyComponent routes={this.state.routecollection} homePageUrl={this.state.homeRoute} />
                                {/* <this.FooterComponent/> */}
                            </Suspense>
                        </Fragment>
                    }
                })()}


            </Fragment>

        )
    }
}

export default MasterLayout